module.exports = __webpack_public_path__ + "img/right_img.a210f663.png";